import { useNavigate } from "@solidjs/router";
import { Show } from "solid-js";

export const CertificateButtons = props => {
	const navigate = useNavigate();

	const isStaged = props.certificate?.meta?.isStagedCertificate;
	const isPaid = props.certificate?.status == 'paid';

	let link = null, caption, state = { projectId: props.projectId, certificateId: null, amendment: 0, stage: 0 };

	if ( !props.certificate ) {
		caption = 'Create';

	} else if ( !isPaid ) {
		link = props.certificate.sk.replace( 'CERTIFICATE#','' );

		caption = 'Edit';

	} else {
		state.certificateId = props.certificate.sk;
		if ( isStaged ) {
			state.stage = ( props.certificate?.meta?.stages?.length ?? 0 ) + 1
			caption = 'Add Stage';
		} else {
			state.amendment = ( props.certificate?.meta?.amendments?.length ?? 0 ) + 1;
			caption = 'Add Amendment';
		}
	}

	return (
		<>
			<button type="button" class="rias px-2 py-1 text-xs" onClick={() => navigate( `/dashboard/certificate/${link ?? 'new'}`, { state } )}>{caption}</button>

			<Show when={isPaid && isStaged}>
				&nbsp;<button type="button" class="rias px-2 py-1 text-xs" onClick={() => navigate( `/dashboard/certificate/new`, { state: { ...state, amendment: ( props.certificate?.meta?.amendments?.length ?? 0 ) + 1 } } )}>Add Amendment</button>
			</Show>
		</>
	)
}